import 'babel-polyfill'
import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import VueYoutube from 'vue-youtube'
import draggable from 'vuedraggable'
import AudioVisual from 'vue-audio-visual'

// import './filters/filters'

Vue.use(draggable)
Vue.use(VueYoutube)
Vue.use(AudioVisual)
// Importar y registrar componentes

import audioPlayer from '@/components/audio-player'
Vue.component("audio-player", audioPlayer);
import audioPlayerB from '@/components/audio-player-b'
Vue.component("audio-player-b", audioPlayerB);
import botonCerrarModal from '@/components/boton-cerrar-modal'
Vue.component("boton-cerrar-modal-app", botonCerrarModal);
import header from '@/components/header'
Vue.component("header-app", header);
import dialogos from '@/components/dialogos'
Vue.component("dialogos-app", dialogos)
import navMenu from '@/components/nav-menu'
Vue.component("nav-menu-app", navMenu)
import modalApp from '@/components/modal'
Vue.component("modal-app", modalApp)
import modalGlosarioApp from '@/components/modal-glosario'
Vue.component("modal-glosario-app", modalGlosarioApp)
import modalInfografia from '@/components/modal-infografia'
Vue.component("modal-infografia-app", modalInfografia)
import youtubeVideoApp from '@/components/youtube-video'
Vue.component("youtube-video-app", youtubeVideoApp)
import slideItemsApp from '@/components/slide-items'
Vue.component("slide-items-app", slideItemsApp)
import dropGingaApp from '@/components/drop-ginga'
Vue.component("drop-ginga-app", dropGingaApp)
import logosApp from '@/components/logos'
Vue.component("logos-app", logosApp)
import carrouselimgApp from '@/components/carrouselimg'
Vue.component("carrouselimg-app", carrouselimgApp)
import scrollDownApp from '@/components/scroll-down'
Vue.component("scrolldown-app", scrollDownApp)
import iconoGlosario from '@/components/icon-glosario'
Vue.component("icono-glosario-app", iconoGlosario);
import iconoGlosario1 from '@/components/icon-glosario1'
Vue.component("icono-glosario1-app", iconoGlosario1);
import seleccionMulti from '@/components/actividad-seleccion-multi'
Vue.component("select-multi-app", seleccionMulti);
import lupaApp from '@/components/img-lupa'
Vue.component("lupa-app", lupaApp)

Vue.config.productionTip = false

Vue.directive('scroll', {
  inserted(el, binding) {
    let f = function (evt) {
      if (binding.value(evt, el)) {
        window.removeEventListener('scroll', f)
      }
    }
    window.addEventListener('scroll', f)
  }
  /*inserted(el, binding) {
    window.addEventListener("scroll", function(){
      alert('scroll')
    })
  }*/
})


Vue.directive('scroll-handle', {
  bind(el, binding){
    const heightScroll = binding.value
    console.log('Directiva1: ',heightScroll)
    window.addEventListener('click', function(){
      if (window.scrollY != heightScroll) {
        //this.$store.commit('nextShow', true)
      }
      //alert('tamaño: ',heightScroll)
    })
  }
  
})

Vue.directive('focus', {
  // When the bound element is inserted into the DOM...
  inserted: function (el) {
    // Focus the element
    el.focus()
    el.scrollIntoView({
      behavior: "smooth"
    })
  },
  componentUpdated: function (el) {
    // Focus the element
    el.focus()
    el.scrollIntoView({
      behavior: "smooth"
    })
  }
})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

